import React from 'react';
import {
  Layout, Menu, Row, Col
} from 'antd';
import FooterWrapper from './styles/FooterWrapper';

const { Footer } = Layout;

const MainFooter = () => (
  <FooterWrapper>
    <Footer>
      <Row justify="center">
        <Col>
          <Menu
            mode="horizontal"
          >
            <Menu.Item key="1">
              <a href="https://www.flex-key.com/contact/" rel="noreferrer" title="Contact" target="_blank">Contact</a>
            </Menu.Item>
            <Menu.Item key="2">
              <a href="https://www.flex-key.com/qui-sommes-nous/" rel="noreferrer" title="À propos" target="_blank">Qui sommes-nous ?</a>
            </Menu.Item>
            <Menu.Item key="3">
              <a href="https://www.flex-key.com/actualites/" rel="noreferrer" title="Actualités" target="_blank">Actualités</a>
            </Menu.Item>
          </Menu>
        </Col>
      </Row>
    </Footer>
  </FooterWrapper>
);

export default MainFooter;
